// Подстановка значений в тексты с метками вида {роль}, {дата} — как они записаны в contracts.

const PLACEHOLDER = /\{[^{}]+\}/g;

/** Метки шаблона по порядку: «с {дата} по {дата}» → ['{дата}', '{дата}']. */
export function placeholders(template: string): string[] {
  return template.match(PLACEHOLDER) ?? [];
}

/** Подставляет значения по порядку меток. Число значений должно совпадать с числом меток. */
export function fillTemplate(template: string, values: readonly string[]): string {
  const count = placeholders(template).length;
  if (count !== values.length) {
    throw new Error(`Шаблон «${template}» ждёт ${count} знач., передано ${values.length}`);
  }
  let i = 0;
  return template.replace(PLACEHOLDER, () => values[i++] ?? '');
}

/** Подставляет значения по имени метки: { домен: 'example.ru' } заменяет каждую {домен}. */
export function fillNamed(template: string, values: Readonly<Record<string, string>>): string {
  return template.replace(PLACEHOLDER, (match) => values[match.slice(1, -1)] ?? match);
}
